import { ICommonResponse } from '../core/api/http-methods/common-response.type';
import { ICampaignList, ICampaignRewards } from '../types/campaign.types';
import { apiClient } from './client';

export interface CampaignListRequest {
  entity_id: string;
  page: number;
  limit: number;
}

export const fetchCampaignList = async (body: CampaignListRequest) => {
  const resp = await apiClient.post<ICommonResponse<ICampaignList[]>>('/campaign/list', body);
  return resp.data;
};

export const fetchCampaignDetails = async (campaign_id: string) => {
  const resp = await apiClient.get<ICommonResponse<ICampaignList>>(`/campaign/${campaign_id}`);
  return resp.data;
}

export const fetchCampaignRewards = async (campaign_id: string) => {
  const resp = await apiClient.get<ICommonResponse<ICampaignRewards>>(`/campaign/${campaign_id}/rewards`);
  return resp.data;
}
